import { ImsAxiosInstance } from '../axios/axios';
import { Address } from 'src/shared/types/Address';

export interface AddressUpdateModel extends Address {
  shouldUpdateCurrentResidence?: boolean;
  shouldUpdatePermanentResidence?: boolean;
  addressType?: string;
  contactAddressId?: number;
}

export interface AddressConfirmationModel {
  beneId?: number;
  mailingAddress?: AddressUpdateModel;
  shouldUpdatePermanentResidence?: boolean;
  shouldUpdateCurrentResidence?: boolean;
}

export interface ServiceNowTicketState {
  beneId?: number;
  state: string;
  notes: string;
}

export interface ServiceNowTicketNotes {
  caseIds: number[];
  notes: string;
}

export const confirmMAC = async (request: AddressConfirmationModel): Promise<any> => {
  const url = 'api/AutomationPendingConfirmation/MAC/Confirm';
  const response = await ImsAxiosInstance.put(url, request);
  return response.data;
};

export const updateMACStatus = async (request: ServiceNowTicketState): Promise<any> => {
  const url = 'api/ServiceNow/updateTicket';
  const response = await ImsAxiosInstance.post(url, request);
  return response.data;
};

export const getMACAddress = async (userId: number): Promise<Address> => {
  try {
    const url = `api/AutomationPendingConfirmation/Address?userId=${userId}`;
    const response = await ImsAxiosInstance.get(url);
    return response.data;
  } catch (error: any) {
    console.error('Error details:', error.response);
    throw error;
  }
};

export const setMACAddressConfirmed = async (request: ServiceNowTicketState): Promise<number[]> => {
  const url = 'api/ServiceNow/setAddressConfirmation';
  const response = await ImsAxiosInstance.post(url, request);
  return response.data;
};

export const updateMACNotes = async (request: ServiceNowTicketNotes): Promise<number[]> => {
  const url = 'api/ServiceNow/updateNotes';
  const response = await ImsAxiosInstance.post(url, request);
  return response.data;
};